import alt from 'components/Dispatcher';
import BrowserActions from 'actions/BrowserActions';
const moment = require('moment-timezone');

/**
 * Stores detected browser details
 */
export class BrowserStore {
  constructor() {
    this.state = {
      // Detected browser time zone, represented as Olson time zone (example: 'Europe/Berlin')
      timezone: '',
      // Time when the user last performed an activity
      lastActive: moment(),
    };
    this.bindActions(BrowserActions);
  }

  /**
   * Get the browser's timezone as guessed by 'moment-timezone'.
   * Note that it doesn't do geo-location, it returns the closest match.
   */
  onGetTimezone() {
    const timezone = moment.tz.guess();
    this.setState({timezone: timezone});
  }

  /**
   * Store current time in lastActive
   */
  onSetLastActive() {
    this.setState({lastActive: moment()});
  }
}

export default alt.createStore(BrowserStore, 'BrowserStore');
